import React, { FC } from 'react'
import PolaroidTextLink from '../PolaroidTextLink'
import styles from '../../Polaroid.module.scss'

type PolaroidartistFullNameProps = {
  onClick?: () => void
  artistLink: string
  artistFullName: string
  artistCountry?: string
}

const PolaroidartistFullName: FC<PolaroidartistFullNameProps> = ({
  onClick,
  artistLink,
  artistFullName,
  artistCountry,
}) => {
  const artistText = artistCountry ? `${artistFullName}, ${artistCountry}` : artistFullName

  return (
    <>
      <PolaroidTextLink
        link={artistLink}
        dataTestId='artwork-artist-name'
        linkDataTestId='artwork-artist-name-link'
        onClick={onClick}
        ariaLabel={`View artist ${artistFullName} profile`}
        customStyles={styles.polaroidArtistRowCustomStyle}
      >
        {artistText}
      </PolaroidTextLink>
    </>
  )
}

export default PolaroidartistFullName
